import { GET_ROSS1000_COMUNI } from './index';

export function getRoss1000Comuni(data) {
  return {
    type: GET_ROSS1000_COMUNI,
    request: {
      op: 'get',
      path: `/@ross1000-comuni`,
    },
  };
}
